import React from "react";
import { CheckCircle2, Link2, Waves, GitMerge, Fingerprint, Users, Filter, Zap, Database, ShieldCheck, Code2 } from "lucide-react";

export const STEP_META = {
  connect: { label: "Connect", icon: Link2 },
  streams: { label: "Data Streams", icon: Waves },
  mapping: { label: "Field Mapping", icon: GitMerge },
  identity: { label: "Identity Resolution", icon: Fingerprint },
  unified: { label: "Unified Profile", icon: Users },
  segment_insight: { label: "Segment & Insight", icon: Filter },
  activate: { label: "Activate", icon: Zap },
};

export const SFMC_STEP_META = {
  connect: { label: "Connect", icon: Link2 },
  streams: { label: "Data Extensions", icon: Waves },
  mapping: { label: "Field Mapping", icon: GitMerge },
  identity: { label: "Contact Linking", icon: Fingerprint },
  unified: { label: "Unified Contact", icon: Users },
  segment_insight: { label: "Audience & Insight", icon: Filter },
  activate: { label: "Journey Activate", icon: Zap },
};

export const MC_NEXT_STEP_META = {
  connect: { label: "Connect", icon: Link2 },
  streams: { label: "Data Streams", icon: Waves },
  mapping: { label: "Field Mapping", icon: GitMerge },
  identity: { label: "Identity Resolution", icon: Fingerprint },
  unified: { label: "Unified Profile", icon: Users },
  segment_insight: { label: "Segment & Agentforce", icon: Filter },
  activate: { label: "Distributed Activate", icon: Zap },
};

export const ADMIN_DEV_STEP_META = {
  objects: { label: "Data Model", icon: Database },
  security: { label: "Security & Sharing", icon: ShieldCheck },
  automation: { label: "Automation", icon: Zap },
  apex_deploy: { label: "Apex & Deployment", icon: Code2 },
};

export const SERVICENOW_STEP_META = {
  cmdb_data: { label: "CMDB & Data Model", icon: Database },
  security_access: { label: "Security & Access", icon: ShieldCheck },
  itsm_workflow: { label: "ITSM & Automation", icon: Zap },
  scripting_deploy: { label: "Scripting & Deployment", icon: Code2 },
};

export default function PipelineStepper({ steps, currentStep, results, onJump, stepMeta = STEP_META }) {
  return (
    <div className="glass-panel rounded-2xl p-4 mb-6 overflow-x-auto" data-testid="pipeline-stepper">
      <div className="flex items-center min-w-max">
        {steps.map((step, i) => {
          const meta = stepMeta[step];
          const Icon = meta.icon;
          const done = !!results[step];
          const active = step === currentStep;
          return (
            <React.Fragment key={step}>
              <button
                onClick={() => onJump(i)} data-testid={`pipeline-step-${step}`}
                className={`flex flex-col items-center gap-1.5 px-2 shrink-0 group`}
              >
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center border-2 transition-colors ${
                    active ? "border-indigo-400 bg-indigo-400/15 text-indigo-300"
                    : done ? "border-emerald-400/60 bg-emerald-400/10 text-emerald-400"
                    : "border-white/10 bg-white/5 text-slate-400 group-hover:border-white/25"
                  }`}
                >
                  {done && !active ? <CheckCircle2 className="w-4.5 h-4.5" /> : <Icon className="w-4.5 h-4.5" />}
                </div>
                <span className={`text-[10px] font-semibold whitespace-nowrap ${active ? "text-indigo-300" : done ? "text-emerald-400" : "text-slate-400"}`}>
                  {meta.label}
                </span>
              </button>
              {i < steps.length - 1 && <div className={`h-px w-6 sm:w-10 shrink-0 ${done ? "bg-emerald-400/40" : "bg-white/10"}`} />}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
